export const TEAM_MEMBERS = [
  {
    id: 'tm-1',
    name: 'Sarah Mitchell',
    email: 'sarah.mitchell@seeddrive.demo',
    role: 'Admin',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '12 Jan 2024',
    dealsAccess: 8,
    jobTitle: 'Platform Administrator',
    phone: '+44 20 7946 0001',
    timezone: 'Europe/London',
    initials: 'SM',
  },
  {
    id: 'tm-2',
    name: 'James Harrison',
    email: 'james.harrison@infraequity.co.uk',
    role: 'Investor',
    organisation: 'GlobalInfra Partners',
    status: 'Active',
    lastActive: '2 hours ago',
    lastActiveDate: new Date(Date.now() - 2 * 3600000),
    dateJoined: '15 Feb 2024',
    dealsAccess: 4,
    jobTitle: 'Senior Investment Director',
    phone: '+44 20 7946 0002',
    timezone: 'Europe/London',
    initials: 'JH',
  },
  {
    id: 'tm-3',
    name: 'Priya Sharma',
    email: 'priya.sharma@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Yesterday',
    lastActiveDate: new Date(Date.now() - 86400000),
    dateJoined: '3 Mar 2024',
    dealsAccess: 6,
    jobTitle: 'Infrastructure Analyst',
    phone: '+44 20 7946 0003',
    timezone: 'Europe/London',
    initials: 'PS',
  },
  {
    id: 'tm-4',
    name: 'Demo Investor',
    email: 'investor@seeddrive.demo',
    role: 'Investor',
    organisation: 'Demo Investor Co.',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '1 Jan 2024',
    dealsAccess: 3,
    jobTitle: 'Investment Manager',
    phone: '+44 20 7946 0004',
    timezone: 'Europe/London',
    initials: 'DI',
  },
  {
    id: 'tm-5',
    name: 'Demo Sponsor',
    email: 'sponsor@seeddrive.demo',
    role: 'Sponsor',
    organisation: 'Greenfield Developments Ltd',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '1 Jan 2024',
    dealsAccess: 5,
    jobTitle: 'Development Director',
    phone: '+44 20 7946 0005',
    timezone: 'Europe/London',
    initials: 'DS',
  },
  {
    id: 'tm-6',
    name: 'Demo Admin',
    email: 'admin@seeddrive.demo',
    role: 'Admin',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '1 Jan 2024',
    dealsAccess: 8,
    jobTitle: 'System Administrator',
    phone: '+44 20 7946 0006',
    timezone: 'Europe/London',
    initials: 'DA',
  },
  {
    id: 'tm-7',
    name: 'Oliver Chen',
    email: 'oliver.chen@sovereignfund.demo',
    role: 'Investor',
    organisation: 'Meridian Sovereign Fund',
    status: 'Active',
    lastActive: '3 days ago',
    lastActiveDate: new Date(Date.now() - 3 * 86400000),
    dateJoined: '20 Feb 2024',
    dealsAccess: 4,
    jobTitle: 'Portfolio Manager',
    phone: '+65 6123 4567',
    timezone: 'Asia/Singapore',
    initials: 'OC',
  },
  {
    id: 'tm-8',
    name: 'Fatima Al-Rashid',
    email: 'fatima.alrashid@dfi.demo',
    role: 'Investor',
    organisation: 'Nordic Development Finance',
    status: 'Active',
    lastActive: '1 week ago',
    lastActiveDate: new Date(Date.now() - 7 * 86400000),
    dateJoined: '5 Mar 2024',
    dealsAccess: 3,
    jobTitle: 'DFI Investment Officer',
    phone: '+47 22 12 3456',
    timezone: 'Europe/Oslo',
    initials: 'FA',
  },
  {
    id: 'tm-9',
    name: 'Tom Baxter',
    email: 'tom.baxter@greenfield.demo',
    role: 'Sponsor',
    organisation: 'Greenfield Developments Ltd',
    status: 'Active',
    lastActive: '5 days ago',
    lastActiveDate: new Date(Date.now() - 5 * 86400000),
    dateJoined: '10 Feb 2024',
    dealsAccess: 5,
    jobTitle: 'Project Development Manager',
    phone: '+44 20 7946 0009',
    timezone: 'Europe/London',
    initials: 'TB',
  },
  {
    id: 'tm-10',
    name: 'Amelia Rhodes',
    email: 'amelia.rhodes@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Yesterday',
    lastActiveDate: new Date(Date.now() - 86400000),
    dateJoined: '18 Mar 2024',
    dealsAccess: 6,
    jobTitle: 'Financial Analyst',
    phone: '+44 20 7946 0010',
    timezone: 'Europe/London',
    initials: 'AR',
  },
  {
    id: 'tm-11',
    name: 'David Park',
    email: 'david.park@infraequity.co.uk',
    role: 'Viewer',
    organisation: 'GlobalInfra Partners',
    status: 'Inactive',
    lastActive: '3 weeks ago',
    lastActiveDate: new Date(Date.now() - 21 * 86400000),
    dateJoined: '22 Jan 2024',
    dealsAccess: 2,
    jobTitle: 'Associate',
    phone: '+44 20 7946 0011',
    timezone: 'Europe/London',
    initials: 'DP',
  },
  {
    id: 'tm-12',
    name: 'Lena Müller',
    email: 'lena.muller@capitalpartners.demo',
    role: 'Investor',
    organisation: 'Capital Partners AG',
    status: 'Pending',
    lastActive: 'Invited 5 days ago',
    lastActiveDate: new Date(Date.now() - 5 * 86400000),
    dateJoined: '—',
    dealsAccess: 0,
    jobTitle: 'Investment Director',
    phone: '+41 44 123 4567',
    timezone: 'Europe/Zurich',
    initials: 'LM',
  },
  // Asset-level staff — aligned with assetData.js canonical records
  {
    id: 'tm-13',
    name: 'David Okafor',
    email: 'david.okafor@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '5 Apr 2024',
    dealsAccess: 8,
    jobTitle: 'Sector Lead (Renewable Energy)',
    phone: '+44 20 7946 0013',
    timezone: 'Europe/London',
    initials: 'DO',
  },
  {
    id: 'tm-14',
    name: 'Tom Hargreaves',
    email: 'tom.hargreaves@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Yesterday',
    lastActiveDate: new Date(Date.now() - 86400000),
    dateJoined: '8 Apr 2024',
    dealsAccess: 4,
    jobTitle: 'Asset Lead (Transport)',
    phone: '+44 20 7946 0014',
    timezone: 'Europe/London',
    initials: 'TH',
  },
  {
    id: 'tm-15',
    name: 'Ana Ferreira',
    email: 'ana.ferreira@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: '2 days ago',
    lastActiveDate: new Date(Date.now() - 2 * 86400000),
    dateJoined: '10 Apr 2024',
    dealsAccess: 5,
    jobTitle: 'Asset Lead (Iberia)',
    phone: '+44 20 7946 0015',
    timezone: 'Europe/Lisbon',
    initials: 'AF',
  },
  {
    id: 'tm-16',
    name: 'Klaus Weber',
    email: 'klaus.weber@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: '3 days ago',
    lastActiveDate: new Date(Date.now() - 3 * 86400000),
    dateJoined: '12 Apr 2024',
    dealsAccess: 3,
    jobTitle: 'Asset Lead (Germany/Elbe)',
    phone: '+49 30 1234 5678',
    timezone: 'Europe/Berlin',
    initials: 'KW',
  },
  {
    id: 'tm-17',
    name: 'Erik Lindqvist',
    email: 'erik.lindqvist@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: '4 days ago',
    lastActiveDate: new Date(Date.now() - 4 * 86400000),
    dateJoined: '15 Apr 2024',
    dealsAccess: 3,
    jobTitle: 'Asset Lead (Nordics)',
    phone: '+46 8 1234 5678',
    timezone: 'Europe/Stockholm',
    initials: 'EL',
  },
  {
    id: 'tm-18',
    name: 'Rachel Patel',
    email: 'rachel.patel@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Yesterday',
    lastActiveDate: new Date(Date.now() - 86400000),
    dateJoined: '18 Apr 2024',
    dealsAccess: 6,
    jobTitle: 'Finance Analyst',
    phone: '+44 20 7946 0018',
    timezone: 'Europe/London',
    initials: 'RP',
  },
  {
    id: 'tm-19',
    name: 'Carlos Reyes',
    email: 'carlos.reyes@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '20 Apr 2024',
    dealsAccess: 4,
    jobTitle: 'Asset Lead (Spain/Solano)',
    phone: '+34 91 123 4567',
    timezone: 'Europe/Madrid',
    initials: 'CR',
  },
  {
    id: 'tm-20',
    name: 'James Thornton',
    email: 'james.thornton@seeddrive.demo',
    role: 'Analyst',
    organisation: 'SeedDrive',
    status: 'Active',
    lastActive: 'Today',
    lastActiveDate: new Date(),
    dateJoined: '22 Apr 2024',
    dealsAccess: 7,
    jobTitle: 'Deal Analyst',
    phone: '+44 20 7946 0020',
    timezone: 'Europe/London',
    initials: 'JT',
  },
];

export const ROLE_CONFIG = {
  Admin: { color: 'bg-[#3b4c4c] text-white', dot: 'bg-[#3b4c4c]', label: 'Admin', avatarBg: '#3b4c4c' },
  Investor: { color: 'bg-[#3b4c4c] text-white', dot: 'bg-[#3b4c4c]', label: 'Investor', avatarBg: '#2563eb' },
  Sponsor: { color: 'bg-teal-600 text-white', dot: 'bg-teal-600', label: 'Sponsor', avatarBg: '#0d9488' },
  Analyst: { color: 'bg-indigo-600 text-white', dot: 'bg-indigo-600', label: 'Analyst', avatarBg: '#4f46e5' },
  Viewer: { color: 'bg-slate-500 text-white', dot: 'bg-slate-500', label: 'Viewer', avatarBg: '#64748b' },
};

export const ROLE_DESCRIPTIONS = {
  Admin: 'Full platform access. Can manage team, settings, and all deals.',
  Investor: 'Can view deals, documents, and portfolio. Cannot edit procurement or team.',
  Sponsor: 'Can manage pipeline, procurement, and deal origination. Cannot manage team.',
  Analyst: 'Can view and annotate deals, run reports. Read-only on financials.',
  Viewer: 'View-only access across permitted deals and documents.',
};

export const PERMISSIONS_MATRIX = [
  { permission: 'View Deals', Admin: 'full', Investor: 'full', Sponsor: 'full', Analyst: 'full', Viewer: 'full' },
  { permission: 'Create Opportunity', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'none', Viewer: 'none' },
  { permission: 'Edit Opportunity', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'limited', Viewer: 'none' },
  { permission: 'Create SPV', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'none', Viewer: 'none' },
  { permission: 'Manage SPV', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'none', Viewer: 'none' },
  { permission: 'View Financials', Admin: 'full', Investor: 'full', Sponsor: 'full', Analyst: 'limited', Viewer: 'none' },
  { permission: 'Export Reports', Admin: 'full', Investor: 'full', Sponsor: 'limited', Analyst: 'full', Viewer: 'none' },
  { permission: 'Manage Documents', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'limited', Viewer: 'none' },
  { permission: 'Upload Documents', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'full', Viewer: 'none' },
  { permission: 'View Data Room', Admin: 'full', Investor: 'full', Sponsor: 'full', Analyst: 'full', Viewer: 'limited' },
  { permission: 'Manage Pipeline', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'none', Viewer: 'none' },
  { permission: 'Manage Procurement', Admin: 'full', Investor: 'none', Sponsor: 'full', Analyst: 'none', Viewer: 'none' },
  { permission: 'View ESG', Admin: 'full', Investor: 'full', Sponsor: 'full', Analyst: 'full', Viewer: 'limited' },
  { permission: 'Manage Team', Admin: 'full', Investor: 'none', Sponsor: 'none', Analyst: 'none', Viewer: 'none' },
  { permission: 'Manage Settings', Admin: 'full', Investor: 'none', Sponsor: 'none', Analyst: 'none', Viewer: 'none' },
  { permission: 'View Audit Trail', Admin: 'full', Investor: 'none', Sponsor: 'none', Analyst: 'limited', Viewer: 'none' },
];

export const PENDING_INVITES = [
  {
    id: 'inv-1',
    email: 'lena.muller@capitalpartners.demo',
    role: 'Investor',
    invitedBy: 'Sarah Mitchell',
    organisation: 'Capital Partners AG',
    dateSent: '5 days ago',
    dateSentFull: new Date(Date.now() - 5 * 86400000),
    expiryDate: 'Expires in 2 days',
    expiryMs: Date.now() + 2 * 86400000,
    status: 'Pending',
  },
  {
    id: 'inv-2',
    email: 'new.analyst@seeddrive.demo',
    role: 'Analyst',
    invitedBy: 'admin@seeddrive.demo',
    organisation: 'SeedDrive',
    dateSent: '1 day ago',
    dateSentFull: new Date(Date.now() - 86400000),
    expiryDate: 'Expires in 6 days',
    expiryMs: Date.now() + 6 * 86400000,
    status: 'Pending',
  },
];

export const AUDIT_TRAIL = [
  { id: 'a-1', timestamp: new Date(Date.now() - 10 * 60000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Role Changed', target: 'James Harrison', description: "James Harrison\'s role changed from Analyst to Investor by Sarah Mitchell.", ip: '192.168.1.10', details: { before: 'Analyst', after: 'Investor', reason: 'Promotion' } },
  { id: 'a-2', timestamp: new Date(Date.now() - 30 * 60000), actor: 'admin@seeddrive.demo', actorInitials: 'DA', actionType: 'Login', target: 'admin@seeddrive.demo', description: 'admin@seeddrive.demo logged in from 192.168.1.1.', ip: '192.168.1.1', details: { method: 'Email/Password', device: 'Chrome / macOS' } },
  { id: 'a-3', timestamp: new Date(Date.now() - 2 * 3600000), actor: 'Priya Sharma', actorInitials: 'PS', actionType: 'Document Access', target: 'Technical Due Diligence Report v2.1', description: 'Priya Sharma accessed Technical Due Diligence Report v2.1 in the Data Room.', ip: '192.168.1.15', details: { document: 'Technical Due Diligence Report v2.1', deal: 'Nairobi Solar Array' } },
  { id: 'a-4', timestamp: new Date(Date.now() - 3 * 3600000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Permission Changed', target: 'Oliver Chen', description: 'Export Reports permission enabled for Oliver Chen by Sarah Mitchell.', ip: '192.168.1.10', details: { permission: 'Export Reports', before: false, after: true } },
  { id: 'a-5', timestamp: new Date(Date.now() - 5 * 3600000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Member Invited', target: 'lena.muller@capitalpartners.demo', description: 'Invitation sent to lena.muller@capitalpartners.demo for Investor role by Sarah Mitchell.', ip: '192.168.1.10', details: { role: 'Investor', organisation: 'Capital Partners AG' } },
  { id: 'a-6', timestamp: new Date(Date.now() - 6 * 3600000), actor: 'admin@seeddrive.demo', actorInitials: 'DA', actionType: 'Member Invited', target: 'new.analyst@seeddrive.demo', description: 'Invitation sent to new.analyst@seeddrive.demo for Analyst role.', ip: '192.168.1.1', details: { role: 'Analyst', organisation: 'SeedDrive' } },
  { id: 'a-7', timestamp: new Date(Date.now() - 86400000), actor: 'James Harrison', actorInitials: 'JH', actionType: 'Login', target: 'james.harrison@infraequity.co.uk', description: 'james.harrison@infraequity.co.uk logged in from 10.0.0.45.', ip: '10.0.0.45', details: { method: 'SSO', device: 'Safari / iOS' } },
  { id: 'a-8', timestamp: new Date(Date.now() - 86400000 - 3600000), actor: 'Priya Sharma', actorInitials: 'PS', actionType: 'Document Access', target: 'Financial Model Q1 2025.xlsx', description: 'Priya Sharma accessed Financial Model Q1 2025.xlsx.', ip: '192.168.1.15', details: { document: 'Financial Model Q1 2025.xlsx', deal: 'Lagos Port Expansion' } },
  { id: 'a-9', timestamp: new Date(Date.now() - 2 * 86400000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Deal Action', target: 'Nairobi Solar Array', description: 'Sarah Mitchell granted deal access to Oliver Chen for Nairobi Solar Array.', ip: '192.168.1.10', details: { deal: 'Nairobi Solar Array', action: 'Access Granted' } },
  { id: 'a-10', timestamp: new Date(Date.now() - 2 * 86400000 - 3600000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Member Deactivated', target: 'David Park', description: 'David Park deactivated by Sarah Mitchell. Reason: Departed organisation.', ip: '192.168.1.10', details: { reason: 'Departed organisation', previousRole: 'Viewer' } },
  { id: 'a-11', timestamp: new Date(Date.now() - 3 * 86400000), actor: 'Oliver Chen', actorInitials: 'OC', actionType: 'Document Access', target: 'ESG Impact Report 2024.pdf', description: 'Oliver Chen accessed ESG Impact Report 2024.pdf in the Data Room.', ip: '203.0.113.42', details: { document: 'ESG Impact Report 2024.pdf', deal: 'Nordic Wind Farm Portfolio' } },
  { id: 'a-12', timestamp: new Date(Date.now() - 3 * 86400000 - 7200000), actor: 'Tom Baxter', actorInitials: 'TB', actionType: 'Deal Action', target: 'Greenfield Solar Phase 2', description: 'Tom Baxter updated procurement status for Greenfield Solar Phase 2.', ip: '192.168.2.20', details: { deal: 'Greenfield Solar Phase 2', action: 'Procurement Updated' } },
  { id: 'a-13', timestamp: new Date(Date.now() - 4 * 86400000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Permission Changed', target: 'Priya Sharma', description: 'View Financials permission changed to limited for Priya Sharma.', ip: '192.168.1.10', details: { permission: 'View Financials', before: 'full', after: 'limited' } },
  { id: 'a-14', timestamp: new Date(Date.now() - 4 * 86400000 - 3600000), actor: 'Fatima Al-Rashid', actorInitials: 'FA', actionType: 'Login', target: 'fatima.alrashid@dfi.demo', description: 'fatima.alrashid@dfi.demo logged in from 185.12.45.67.', ip: '185.12.45.67', details: { method: 'Email/Password', device: 'Firefox / Windows' } },
  { id: 'a-15', timestamp: new Date(Date.now() - 5 * 86400000), actor: 'admin@seeddrive.demo', actorInitials: 'DA', actionType: 'Role Changed', target: 'Amelia Rhodes', description: "Amelia Rhodes\' role changed from Viewer to Analyst by admin@seeddrive.demo.", ip: '192.168.1.1', details: { before: 'Viewer', after: 'Analyst', reason: 'Role upgrade' } },
  { id: 'a-16', timestamp: new Date(Date.now() - 6 * 86400000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Deal Action', target: 'Lagos Port Expansion', description: 'Sarah Mitchell revoked deal access for David Park on Lagos Port Expansion.', ip: '192.168.1.10', details: { deal: 'Lagos Port Expansion', action: 'Access Revoked' } },
  { id: 'a-17', timestamp: new Date(Date.now() - 7 * 86400000), actor: 'James Harrison', actorInitials: 'JH', actionType: 'Document Access', target: 'Investment Committee Memo v3.pdf', description: 'James Harrison accessed Investment Committee Memo v3.pdf.', ip: '10.0.0.45', details: { document: 'Investment Committee Memo v3.pdf', deal: 'Nairobi Solar Array' } },
  { id: 'a-18', timestamp: new Date(Date.now() - 8 * 86400000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Member Invited', target: 'tom.baxter@greenfield.demo', description: 'Invitation sent to tom.baxter@greenfield.demo for Sponsor role. Invitation accepted.', ip: '192.168.1.10', details: { role: 'Sponsor', status: 'Accepted' } },
  { id: 'a-19', timestamp: new Date(Date.now() - 10 * 86400000), actor: 'admin@seeddrive.demo', actorInitials: 'DA', actionType: 'Permission Changed', target: 'James Harrison', description: 'View Data Room permission enabled for James Harrison.', ip: '192.168.1.1', details: { permission: 'View Data Room', before: false, after: true } },
  { id: 'a-20', timestamp: new Date(Date.now() - 14 * 86400000), actor: 'Sarah Mitchell', actorInitials: 'SM', actionType: 'Member Invited', target: 'fatima.alrashid@dfi.demo', description: 'Invitation sent to fatima.alrashid@dfi.demo for Investor role. Invitation accepted.', ip: '192.168.1.10', details: { role: 'Investor', status: 'Accepted' } },
];

export const ACTIVE_DEALS = [
  'Nairobi Solar Array',
  'Lagos Port Expansion',
  'Nordic Wind Farm Portfolio',
  'Greenfield Solar Phase 2',
  'Cairo Water Treatment',
  'Accra Logistics Hub',
  'Cape Town Renewable Grid',
  'Dar es Salaam Port',
];

export const AUDIT_ACTION_TYPES = [
  'All',
  'Role Changed',
  'Member Invited',
  'Member Deactivated',
  'Permission Changed',
  'Login',
  'Document Access',
  'Deal Action',
];

export const AUDIT_ACTION_COLORS = {
  'Role Changed': 'bg-purple-100 text-purple-700',
  'Member Invited': 'bg-blue-100 text-blue-700',
  'Member Deactivated': 'bg-red-100 text-red-700',
  'Permission Changed': 'bg-amber-100 text-amber-700',
  'Login': 'bg-green-100 text-green-700',
  'Document Access': 'bg-slate-100 text-slate-700',
  'Deal Action': 'bg-teal-100 text-teal-700',
};
